import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderTvRemoteShellComponent } from './order-tv-remote-shell.container';
import { PlaceRemoteOrderShellComponent } from './place-remote-order-shell.container';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full',
  },
  {
    path: 'contact',
    data: {
      uid: 'dc_order-tv-remote-contact',
    },
    loadComponent: () =>
      import('@/shared/feature/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'api-failure',
    data: {
      uid: 'dc_order-tv-remote-contact-issue-placing-order',
    },
    loadComponent: () =>
      import('@/shared/feature/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'older-tv-box',
    data: {
      uid: 'dc_order-tv-remote-contact-older-tv-box',
    },
    loadComponent: () =>
      import('@/shared/feature/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'place-order-offline',
    data: {
      uid: 'dc_order-tv-remote-contact-place-order-offline',
    },
    loadComponent: () =>
      import('@/shared/feature/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'issue-placing-order',
    data: {
      uid: 'dc_order-tv-remote-contact-issue-placing-order',
    },
    loadComponent: () =>
      import('@/shared/feature/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
  },
  {
    path: 'place-order',
    component: PlaceRemoteOrderShellComponent,
  },
  {
    path: ':page',
    component: OrderTvRemoteShellComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderTVRemoteRoutingModule {}
